const jp = {
	login: 'ログインする',
	logout: 'ログアウト',
	signin: 'サインイン',
	signup: 'サインアップ',
	email: 'Eメール',
	emailAddr: '電子メールアドレス',
	password: 'パスワード',
	rememberMe: '私を覚えてますか',
	forgotYourPwd: 'パスワードをお忘れですか？',
	signinFacebook: 'Facebookでサインイン',
	signinGoogle: 'グーグルでサインイン',
	dontAccount: 'アカウントを持っていないのですか？',
	firstName: 'ファーストネーム',
	lastName: '苗字',
	confirmPwd: 'パスワードを認証する',
	signup_msg: '今すぐ参加をクリックすると、',
	digitX_user_agreement: 'DigitXchangeユーザー契約',
	privacy_policy: '個人情報保護方針',
	and: 'そして',
	cookies_policy: 'クッキーポリシー',
	have_account: 'すでにアカウントをお持ちですか',
	forgotPwd: 'パスワードを忘れた',
	recoverPwd: 'パスワードを回復',
	forgotPwd_msg: 'メールを上のフィールドに入力してください。フォローするための手順を記載したリンクをお送りします。',
	changePwd: 'パスワードを変更する',
	oldPwd: '以前のパスワード',
	newPwd: '新しいパスワード',
	confirmNewPwd: '新しいパスワードを確認',
	user_account: 'ユーザーアカウント',
	change_pic: '写真を変える',
	mobile_number: '携帯電話番号',
	country: '国',
	update_settings: '設定を更新',
	company: '会社',
	aboutUs: '私たちに関しては',
	tos: 'TOS',
	copyright: '著作権',
	socialMedia: 'ソーシャルメディア',
	forUpdates: 'アップデート用',
	footer_msg_1: 'サインアップすることにより、あなたは受け入れます',
	terms: '利用規約',
	contactUs: 'お問い合わせ',
	yourEmail: 'あなたのメール',
	required: '必須',
	yourMsg: 'あなたのメッセージ',
	sent: '送信しました',
	footer_msg_2: 'すべての権利予約',
	footer_msg_3: 'すべての製品名、商標、および登録商標は、それぞれの所有者の財産です。',
	doom: 'ドゥームIII',
	filter: 'フィルタ',
	add_asset: 'アセットを追加',
	request_game: 'ゲームをリクエスト',
	search_msg: '申し訳ありませんが、検索キーワードに一致するものはありません。',
	post: '役職',
	asset: '資産',
	create: '作成する',
	character: 'キャラクター',
	characters: 'キャラクター',
	assets: '資産',
	profile: 'プロフィール',
	game: 'ゲーム',
	games: 'ゲーム',
	currency: '通貨',
	store: 'お店',
	all_time: 'いつも',
	this_month: '今月',
	trending: '急上昇',
	item_name: '項目名',
	view_item: 'アイテムの表示',
	leaderboard: 'リーダーボード',
	posters: 'ポスター',
	chinese: '中国語',
	english: '英語',
	japanese: '日本語',
	korean: '韓国語',
	german: 'ドイツ人語',
	french: 'フランス語',
	spanish: 'スペイン語',
	italian: 'イタリアの語',
	russian: 'ロシア語',
	portuguese: 'ポルトガル語',
	hindi: 'ヒンディー語',
	arabic: 'アラビア語',
	buy: '購入',
	subscription: '申し込み',
	buy_subscription: 'サブスクリプションを購入',
	gift: '贈り物',
	xchange: 'Xchange',
	subscription_plan: 'サブスクリプションプラン',
	payment_options: '支払いオプション',
	cardholder_name: 'クレジットカード名義人氏名',
	submit_order: '注文を送信',
	card_number: 'カード番号',
	cvv: 'CVV',
	expiration_date: '賞味期限',
	buyXchange: 'Xchangeを購入する',
	giftXchange: 'ギフト交換',
	or: 'または',
	select: '選択する',

	search: '探す',
	search_games: 'ゲームを検索...',
	search_assets: 'アセットを検索...',
	platform: 'プラットホーム',
	total_posts: '合計投稿',
	total_comments: '合計コメント',
	total_characters: '総文字数',
	total_assets: '総資産',
	xchange_currency: 'エクスチェンジ通貨',
	subscription_days_remaining: '残りのサブスクリプション日',
	total_asset_networth: '総資産ネットワース',
	total_character_networth: 'トータルキャラクターネットワース',
	most_downloaded: '最もダウンロードされた',
	recently_added: '最近追加された',
	genre: 'ジャンル',
	my_library: 'マイライブラリ',
	most_commented: 'ほとんどのコメント',
	most_recent: '最も最近の',
	nearing_addition: '間近の追加',
	create_asset: 'アセットを作成',
	create_character: 'キャラクター作成',
	asset_name: '資産名',
	asset_type: '資産タイプ',
	rarity: 'レアリティ',
	enhancements: '機能強化',
	add: '追加',
	currency_type: '通貨の種類',
	price: '価格',
	description: '説明',
	upload_asset: 'アセットをアップロード',
	preview_asset: 'アセットをプレビュー',
	main_image: 'メイン画像',
	upload_video: 'ビデオをアップロード',
	upload: 'アップロードする',
	view_demo: 'デモを見る',
	character_name: 'キャラクター名',
	character_type: 'キャラクタータイプ',
	upload_character: 'キャラクターをアップロード',
	preview_character: 'キャラクターのプレビュー',
	race: '人種',
	class: 'クラス',
	gender: '性別',
	level: 'レベル',
	showing: '表示中',
	of: 'の',
	results: '結果',
	featured_characters: '注目のキャラクター',
	url: 'URL',
	submit: '参加する',
	real_world: '現実の世界',
	game_currency: 'ゲーム通貨',
	all: 'すべて',

	edit: '編集する',
	save: '保存する',
	agg_character_networth: '集約された文字Networth',
	agg_time_played: '総再生時間',
	agg_asset_value: '総資産価値',
	enter_character_creation_date: 'キャラクター作成日を入力',
	in_game_currency: 'ゲーム通貨',
	real_world_value: '現実の価値',
	update_character: 'キャラクターを更新',
	item_not_found: 'アイテムが見つかりません！',
	ripper: 'リッパー',
	comments: 'コメント',
	add_comments: 'コメントを追加',
	new_suggested_price: '新しい希望価格',
	sort_by: '並び替え',
	reply: '応答',
	asset_networth: '資産ネットワース',
	join_date: '参加日',
	report: '報告する',
	first: '最初',
	last: '最終',
	most_replies: 'ほとんどの返信',
	new_pricing_recommendations: '新しい価格の推奨事項',
	xchange_amount: 'エクスチェンジ金額',
	username: 'ユーザー名',
	send_gift: 'ギフトを送る',
	message: 'メッセージ',
	gift_text: 'ここにメッセージをパーソナライズ',
	day: '日',
	days: '日々',
	currency_converter: '通貨換算',
	from: 'から',
	to: 'に',
	in_game: 'ゲームで',
	real_life: '実生活',
	cvc: 'CVC',
	card: 'カード',
	per_month: '毎月（月額3ドル）',
	per_year: '年間（年間30ドル）',
	aboutUs_text: 'DigitXChangeはコミュニティ主導のWebサイトであり、クラウドソーシングを通じてデジタル商品やサービスの価値を最終的に評価することを目的としています。 「私のキャラクターの実際の価値はどれくらいですか」または「別のゲームの別のプレーヤーとのフェアトレードはどうなのだろう」と質問したことがある場合は、これ以上答えを探す必要はありません。私たちはあなたが私たちのサイトを楽しんで、グループ知識の構築に参加し、苦労して稼いだ戦利品を披露し、最終的にあなたの総デジタル純資産を見つけるのを楽しみにしています！',
	home: 'ホームページ',
	all_time_characters: 'すべての時間のキャラクター',
	this_month_characters: '今月のキャラクター',
	trending_characters: 'トレンドキャラクター',
	all_time_posters: 'オールタイムポスター',
	this_month_posters: '今月のポスター',
	trending_posters: 'トレンドポスター',
	
};

export default jp;


// WEBPACK FOOTER //
// ./src/translations/jp.js